module.exports = __webpack_public_path__ + "img/cloud_shell.be102f7a.png";